import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import PillLabel from '../../../components/PillLabel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { StripeCard } from '../../../interfaces/stripe_payment_method';
import { BuildingLibraryIcon } from '@heroicons/react/20/solid';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  card: StripeCard;
  onClick: () => void;
};

const StripeCardView: React.FC<Props> = ({ card, onClick }) => {
  const isEditMode = useSelector<RootState, boolean>(
    state => state.payment.edit_mode,
  );
  return (
    <div className="py-2 px-4 bg-surface rounded" onClick={onClick}>
      <div className="flex flex-col p-4 bg-primary/10 h-full rounded-lg shadow-lg items-center justify-center align-middle">
        <div className="flex flex-row w-full items-center justify-between">
          <div className="text-gray-900 flex flex-row items-center text-sm text-left justify-left content-center">
            {card?.type === 'card' ? (
              <FontAwesomeIcon
                icon={faCreditCard as IconProp}
                color="green"
                className=""
              />
            ) : (
              <BuildingLibraryIcon color="green" className="h-4 w-4" />
            )}
            {/* <FontAwesomeIcon icon={faCreditCard} color="green" className="" /> */}
            <div className="pl-2 items-center text-on-surface">
              {card?.type === 'card'
                ? card?.card?.brand?.toUpperCase()
                : card?.us_bank_account?.bank_name?.toUpperCase()}
            </div>
            <div className="pl-2 text-on-surface">
              {card?.type === 'card'
                ? card?.card?.last4
                : card?.us_bank_account?.last4}
            </div>
          </div>
          <div className=" flex flex-row items-center text-sm text-right justify-right content-center">
            <PillLabel
              color={isEditMode ? 'bg-tertiary' : 'bg-primary'}
              label={isEditMode ? 'Delete' : 'Select'}
              text_color={isEditMode ? 'text-on-tertiary' : 'text-on-primary'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StripeCardView;
